export default function Conditional({ children, condition }) {
  if (condition)
    return children || null;
  else
    return null;
}
